<template>
  <div class="horizon-container">
    <div id="moveLeft" class="h-100 flex-column bg-ff" style="width: 200px">
      <div class="left-top">
        <div class="flex-1 font-16-30313a">单据类型</div>
      </div>
      <div class="flex-1 h-0" v-if="menuList">
        <cate-menu :menu-data="menuList" :not-operate="true" @on-choose="onChooseMenu" :choose-id="chooseMenuId"></cate-menu>
      </div>
    </div>
    <move-horizon></move-horizon>
    <div class="flex-1 w-0">
      <div style="padding: 10px 20px 20px 0" class="flex-column h-100">
        <div class="flex content-top mb-10">
          <div class="flex-1 bg-ff h-100 flex align-center pl-10 ptb-5">
            <div class="flex align-center mr-20 cursor">
              <div class="mr-5 decoration-line"></div>
              <div class="font-bold font-16-f5971d">{{currentMenu.name}} - 单据参数定义</div>
            </div>
          </div>
        </div>
        <div class="flex-1" style="border-radius: 10px">
          <div class="h-100 flex-column bg-ff">
            <div class="flex-1 h-0">
              <div class="h-100 p-20">
                <div class="flex mb-10">
                  <div class="tip-16-round-30313a" style="background: #ff5555" v-if="currentMenu.name.indexOf('退') > -1">
                    退单
                  </div>
                  <div class="tip-16-round-30313a" v-else>
                    正单
                  </div>
                </div>
                <div class="flex align-center mb-10">
                  <div class="font-14-30313a font-bold">编码方案：</div>
                  <el-input v-model="data.orderCode" style="width: 70px"></el-input>
                  <!--<div class="font-12-30313a flex-1 text-left">{{data.orderCode}}</div>-->
                </div>
                <div class="flex align-center mb-10">
                  <div class="font-14-30313a font-bold">退单关联：</div>
                  <el-select v-model="data.chargebackOrder" placeholder="请选择">
                    <el-option
                      v-for="item in menuList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name">
                    </el-option>
                  </el-select>
                  <!--<el-input v-model="data.chargebackOrder" style="width: 70px"></el-input>-->
                  <!--<div class="font-12-30313a text-left">{{data.chargebackOrder}}</div>-->
                </div>
                <div class="flex align-center border-b-dashed-e2" style="padding-bottom: 20px;">
                  <div class="font-14-30313a font-bold">记账类型：</div>
                  <el-select v-model="data.accountingTypeName" placeholder="请选择">
                    <el-option
                      v-for="item in accountType"
                      :key="item"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                  <!--<div class="font-12-30313a text-left">{{data.accountingType === 'auxiliary' ? '辅材' : data.accountingType === 'project' ? '主材' : data.accountingType === 'soft' ? '软装' : ''}}</div>-->
                </div>
                <div class="ptb-20 border-b-dashed-e2 flex align-center">
                  <div class="font-14-30313a font-bold">材料开单比例：</div>
                  <el-input v-model="data.orderProportion" type="number" style="width: 70px"></el-input>
                  <div class="flex-1 ml-5 font-12-ff5555 text-left">（比例为0时不控制）</div>
                </div>
                <div class="ptb-20 border-b-dashed-e2">
                  <div class=" flex align-center">
                    <div class="font-14-30313a font-bold">数据只来源于单据：</div>
                    <el-checkbox v-model="data.isSourceOrder" :true-label="1" :false-label="-1"></el-checkbox>
                    <div class="flex-1"></div>
                  </div>
                  <div v-if="data.isSourceOrder === 1" class="flex align-center mt-10">
                    <div class="font-14-30313a font-bold">来源单据：</div>
                    <el-select v-model="data.sourceOrderId" placeholder="请选择">
                      <el-option
                        v-for="item in orderDefineList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                    <div class="flex-1"></div>
                  </div>
                </div>
                <div class="ptb-20 border-b-dashed-e2 flex align-center">
                  <div class="font-14-30313a font-bold">采购价/成本价：</div>
                  <el-select v-model="data.costPriceField" placeholder="请选择">
                    <el-option
                      v-for="item in priceList"
                      :key="item.priceField"
                      :label="item.name"
                      :value="item.priceField">
                    </el-option>
                  </el-select>
                  <div class="font-12-30313a mr-10" style="margin-left: 20px">新增时允许修改</div>
                  <el-checkbox v-model="data.costPriceAdd" :true-label="1" :false-label="-1"></el-checkbox>
                  <div class="font-12-30313a mr-10" style="margin-left: 20px">修改时允许修改</div>
                  <el-checkbox v-model="data.costPriceModify" :true-label="1" :false-label="-1"></el-checkbox>
                </div>
                <div class="flex align-center mt-10 ptb-20">
                  <div class="font-14-30313a font-bold">销售价：</div>
                  <el-select v-model="data.customerPriceField" placeholder="请选择">
                    <el-option
                      v-for="item in priceList"
                      :key="item.priceField"
                      :label="item.name"
                      :value="item.priceField">
                    </el-option>
                  </el-select>
                  <div class="font-12-30313a mr-10" style="margin-left: 20px">新增时允许修改</div>
                  <el-checkbox v-model="data.customerPriceAdd" :true-label="1" :false-label="-1"></el-checkbox>
                  <div class="font-12-30313a mr-10" style="margin-left: 20px">修改时允许修改</div>
                  <el-checkbox v-model="data.customerPriceModify" :true-label="1" :false-label="-1"></el-checkbox>
                  <div class="flex-1"></div>
                </div>
              </div>
            </div>
            <div style="height: 50px; border-top: 1px solid #e2e2e2" class="flex align-center justify-center">
              <div class="btn-30-border-85 mr-10" @click="getData">重置</div>
              <div class="btn-30-bg-f5971d-s" @click="onSave">保存</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CateMenu from '../../components/CateMenu'
import MoveHorizon from '../../components/MoveHorizon'
export default {
  name: 'materialOrderDefine',
  components: {CateMenu, MoveHorizon},
  data () {
    return {
      chooseMenuId: 11,
      currentMenu: {
        name: '材料出库单',
        id: 11
      },
      menuList: [
        {
          name: '材料出库单',
          id: 11
        },
        {
          name: '材料出库退单',
          id: 13
        },
        {
          name: '材料入库单',
          id: 10
        },
        {
          name: '材料入库退单',
          id: 12
        },
        {
          name: '辅材调拨单',
          id: 2
        },
        {
          name: '辅材调拨退料单',
          id: 5
        },
        {
          name: '主材调拨单',
          id: 1
        },
        {
          name: '主材调拨退料单',
          id: 4
        },
        {
          name: '软装调拨单',
          id: 3
        },
        {
          name: '软装调拨退料单',
          id: 6
        },
        {
          name: '报损单',
          id: 14
        },
        {
          name: '报溢单',
          id: 15
        },
        {
          name: '主材补货单',
          id: 7
        }
      ],
      data: [],
      orderDefineList: [{
        id: -1,
        name: '需用量表'
      }],
      accountType: ['主材', '辅材', '软装'],
      priceList: []
    }
  },
  created () {
    this.getData()
    this.axios.post('orderDefine/list', {companyId: this.$store.state.companyId}).then(res => {
      if (res.data.success) {
        this.orderDefineList = this.orderDefineList.concat(res.data.data)
      } else {
        this.$message({
          message: res.data.msg,
          type: 'error',
          offset: 400
        })
      }
    })
    this.axios.post('materialPrice/getPriceList').then(res => {
      if (res.data.success) {
        this.priceList = res.data.data
      } else {
        this.$message({
          message: res.data.msg,
          type: 'error',
          offset: 400
        })
      }
    })
  },
  mounted () {},
  methods: {
    onSave () {
      if (this.data.sourceOrderId) {
        for (let i = 0; i < this.orderDefineList.length; i++) {
          if (this.orderDefineList[i].id === this.data.sourceOrderId) {
            this.data.sourceOrder = this.orderDefineList[i].name
            break
          }
        }
      }
      if (this.data.costPriceField) {
        for (let i = 0; i < this.priceList.length; i++) {
          if (this.priceList[i].priceField === this.data.costPriceField) {
            this.data.costPriceName = this.priceList[i].name
            break
          }
        }
      }
      if (this.data.customerPriceField) {
        for (let i = 0; i < this.priceList.length; i++) {
          if (this.priceList[i].priceField === this.data.customerPriceField) {
            this.data.customerPriceName = this.priceList[i].name
            break
          }
        }
      }
      if (this.data.accountingTypeName) {
        if (this.data.accountingTypeName === '辅材') {
          this.data.accountingType = 'auxiliary'
        } else if (this.data.accountingTypeName === '主材') {
          this.data.accountingType = 'project'
        } else if (this.data.accountingTypeName === '软装') {
          this.data.accountingType = 'soft'
        }
      }
      this.axios.post('orderDefine/modify', this.data).then(res => {
        if (res.data.success) {
          this.$message.success('定义成功！')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    getData () {
      this.axios.post('orderDefine/findOne', {companyId: this.$store.state.companyId, type: this.chooseMenuId}).then(res => {
        if (res.data.success) {
          let list = res.data.data
          if (list.accountingType === 'auxiliary') {
            list.accountingTypeName = '辅材'
          } else if (list.accountingType === 'project') {
            list.accountingTypeName = '主材'
          } else if (list.accountingType === 'soft') {
            list.accountingTypeName = '软装'
          }
          this.data = list
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onChooseMenu (menu) {
      if (menu.id !== this.chooseMenuId) {
        this.chooseMenuId = menu.id
        this.currentMenu = menu
        this.getData()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .left-top {
    display: flex;
    align-items: center;
    padding: 0 10px 0 20px;
    border-bottom: 1px solid #e2e2e2;
    height: 40px;
    text-align: left;
    cursor: pointer;
  }
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #f5971d;
    border-radius: 4px;
  }
  .tip-16-round-30313a {
    height: 16px;
    line-height: 16px;
    padding: 0 10px;
    color: #ffffff;
    font-size: 12px;
    background: #30313a;
    border-radius: 99px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/systemDefine/materialOrderDefine.vue